import {
  atom,
  selector
} from 'recoil';

// Hypothetical function for initial business status fetch if needed
const fetchBusinessStatus = async () => {
  // Implement fetching initial business status if applicable, otherwise return a default structure
  return {
    isLoading: false,
    isMatched: null,
    error: null,
    businessName: null,
    regNumber: null,
    vatNumber: null,
    businessId:null
  };
};

// Selector for default business verification state
const businessVerificationDefault = selector({
  key: 'businessVerificationDefault',
  get: async () => await fetchBusinessStatus()
});

export const businessVerificationState = atom({
  key: 'businessVerificationState',
  default: businessVerificationDefault
});

export const verifyBusiness = selector({
  key: 'verifyBusiness',
  get: () => {},
  set: ({ set }) => {
    set(businessVerificationState, (prevState) => ({
      ...prevState,
      isLoading: true,
      error: null,
      isMatched: false,
      businessId:null,
      businessName: null,
      regNumber: null,
      vatNumber: null
    }));
  }
});
